/**
 * Preselects series checkboxes of the download center from the ?serie= query
 * parameter (comma separated slugs). Returns true if at least one box was checked.
 */
export function preselectSeriesFromUrl(serieBoxes, activeSeries) {
    const raw = new URLSearchParams(window.location.search).get('serie');
    if (!raw) return false;

    const wanted = raw.split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
    let found = false;

    serieBoxes.forEach(box => {
        if (wanted.includes((box.value || '').toLowerCase())) {
            box.checked = true;
            activeSeries.add(box.value);
            found = true;
        }
    });

    return found;
}
